import { useQuery } from '@tanstack/react-query'
import { useCustomerId } from 'features/customers/hooks/useCustomerId'

import { get } from 'utils/http'

export const useCustomerWorkflows = () => {
  const customerId = useCustomerId()

  return useQuery({
    queryKey: ['customer', customerId, 'workflows'],
    queryFn: () => get(`/management/customers/${customerId}/workflows`),
  })
}
